import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontWeights } from '../../utils/typography';
import Hr from '../Hr';
import { HeaderElements } from '../Text/types';
import { HeaderWithRuleContainer, HeaderWithRuleText } from './styles';
const HeaderWithRule = ({ textWeight = FontWeights.Regular, textColor = 'black', hrWeight, hrColor, hrOpacity, el, fontSize, children, }) => {
    const hrProps = {
        weight: hrWeight,
        color: hrColor,
        opacity: hrOpacity,
    };
    return (_jsxs(HeaderWithRuleContainer, { children: [_jsx(Hr, Object.assign({}, hrProps)), _jsx(HeaderWithRuleText, { weight: textWeight, color: textColor, size: fontSize, el: el !== null && el !== void 0 ? el : HeaderElements.H2, children: children }), _jsx(Hr, Object.assign({}, hrProps))] }));
};
export default HeaderWithRule;
//# sourceMappingURL=index.js.map